import { cn } from '@/context/global/utils/cn';

type IconMicrophoneOnProps = {
  size?: number;
  className?: string;
};

const IconMoveToTop = ({ size = 32, className }: IconMicrophoneOnProps) => {
  return (
    <svg
      className={cn('fill-current', className)}
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.6804 4.67784H6.88043C6.44709 4.67784 6.1582 4.38895 6.1582 3.95562C6.1582 3.52229 6.44709 3.2334 6.88043 3.2334H14.6804C15.1138 3.2334 15.4026 3.52229 15.4026 3.95562C15.4026 4.38895 15.1138 4.67784 14.6804 4.67784Z"
        fill="currentColor"
      />
      <path
        d="M14.6804 7.49425H6.88043C6.44709 7.49425 6.1582 7.20536 6.1582 6.77203C6.1582 6.33869 6.44709 6.0498 6.88043 6.0498H14.6804C15.1138 6.0498 15.4026 6.33869 15.4026 6.77203C15.4026 7.20536 15.1138 7.49425 14.6804 7.49425Z"
        fill="currentColor"
      />
      <path
        d="M14.6804 10.3111H6.88043C6.44709 10.3111 6.1582 10.0223 6.1582 9.58892C6.1582 9.15559 6.44709 8.8667 6.88043 8.8667H14.6804C15.1138 8.8667 15.4026 9.15559 15.4026 9.58892C15.4026 10.0223 15.1138 10.3111 14.6804 10.3111Z"
        fill="currentColor"
      />
      <path
        d="M14.6804 13.1276H6.88043C6.44709 13.1276 6.1582 12.8387 6.1582 12.4053C6.1582 11.972 6.44709 11.6831 6.88043 11.6831H14.6804C15.1138 11.6831 15.4026 11.972 15.4026 12.4053C15.4026 12.8387 15.1138 13.1276 14.6804 13.1276Z"
        fill="currentColor"
      />
      <path
        d="M4.78655 7.06096L2.6921 2.87207L0.597656 7.06096H1.96988V12.4054C1.96988 12.8387 2.25877 13.1276 2.6921 13.1276C3.12543 13.1276 3.41432 12.8387 3.41432 12.4054V7.06096H4.78655Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default IconMoveToTop;
